var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "job-active-filter" }, [
    _vm.hasFilterValues
      ? _c("header", [
          _c("div", [_vm._v("Aktive Filter")]),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("resetFilterValues")
                  }
                }
              },
              [
                _c("Icon", { attrs: { icon: "bin" } }),
                _vm._v("\n\t\t\t\tAlle entfernen\n\t\t\t")
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "job-active-filter--groups" },
      _vm._l(_vm.filterValuesGroupedByRow, function(item) {
        return _c(
          "div",
          { key: item.row.id, staticClass: "job-active-filter--group" },
          [
            _c("div", { staticClass: "job-active-filter--group-title" }, [
              _vm._v(_vm._s(item.row.label))
            ]),
            _vm._v(" "),
            _vm._l(item.values, function(value) {
              return _c("ul", [
                _c("li", [
                  _c("span", [_vm._v(_vm._s(value.label))]),
                  _vm._v(" "),
                  _c("span", [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("removeFilterValue", value)
                          }
                        }
                      },
                      [_c("Icon", { attrs: { icon: "bin" } })],
                      1
                    )
                  ])
                ])
              ])
            })
          ],
          2
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }